// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"CanvasFrameTitleInput_inputContainer__3LEou","input":"CanvasFrameTitleInput_input__2aBvJ"};